var map = {
	"./Backgroundalex.png": 53963,
	"./Backgroundsteve.png": 73393,
	"./Foldsalex.png": 89045,
	"./Foldssteve.png": 91847,
	"./Labels.png": 20726,
	"./Notch.png": 5114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89522;